import {
  Box,
  Flex,
  Text,
} from '@chakra-ui/react';
import { TRAFFIC_LIGHT_COLOURS as COLOURS, deliveryPerformanceLegend, QUARTERS } from '@src/modules/performance/shared/constants';
import { useDeliveryPerformanceKPI } from '@src/modules/performance/context/map-api-hooks';
import { mapValueToColourRange, roundKpiValue } from '@src/modules/performance/shared/helpers';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import IndicatorLegend from '@src/modules/performance/components/IndicatorLegend';
import ReportHeader from './ReportHeader';

const subheader = 'Works Completed and Costs';
const informationSource = {
  title: 'Works Completed',
  content: [
    {
      title: 'Variance %',
      description:
  <Box mb={2}>
    <Text fontSize="inherit" mb={2}>The indicator shows the colour grade for the cumulative variance in Approved vs Claimed spend (excluding Emergency Works), up to the reported quarter in the current NLTP:</Text>
    <IndicatorLegend items={deliveryPerformanceLegend} />
  </Box>,
      source: <Text fontSize="inherit" as="span">Approved and claimed road maintenance costs sourced from NZTA.</Text>,
    },
  ],
};

function RoadMaintenanceDeliveryReportHeader({ ...rest }) {
  const { data: deliveryPerformanceData, isLoadingKpi } = useDeliveryPerformanceKPI();
  const colour = mapValueToColourRange(deliveryPerformanceData?.varianceExclEmergency, 'deliveryPerformance');

  return (
    <ReportHeader
      title="Road Maintenance Delivery"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      {deliveryPerformanceData?.varianceExclEmergency !== null && (
      <Flex align="center" ml={4}>
        <Box mr={3}>
          <CircleIndicator
            size={60}
            colour={COLOURS[colour]}
            value={deliveryPerformanceData?.varianceExclEmergency !== null && deliveryPerformanceData?.varianceExclEmergency !== undefined ? `${roundKpiValue(deliveryPerformanceData?.varianceExclEmergency, 5, 1)}%` : null}
            isLoading={isLoadingKpi}
            padding={0}
          />
        </Box>
        <Box>
          <Text fontWeight="bold" color="gray" fontSize="sm">
            Variance
            <br />
            <Text as="span" fontSize="xs" color="gray">
              as at
              {' '}
              {QUARTERS.find((q) => q.id === parseInt(deliveryPerformanceData?.quarter, 10))?.label}
              {' '}
              {deliveryPerformanceData?.lockYear}
            </Text>
          </Text>
        </Box>
      </Flex>
      )}
    </ReportHeader>
  );
}

export default RoadMaintenanceDeliveryReportHeader;
